import Swiper, { Navigation, Pagination } from 'swiper'

import HeaderNavigation from './components/Navigation'

Swiper.use([Navigation, Pagination])

HeaderNavigation.init()

const defaultPaginationSettings = {
  type: 'bullets',
  bulletClass: 'pagination__bullet',
  bulletActiveClass: 'pagination__bullet--active',
  modifierClass: '',
  horizontalClass: '',
  clickable: true
}

const homeSwiper = new Swiper('#homeSwiper', {
  loop: true,
  centeredSlides: true,
  centeredSlidesBounds: true,
  slidesPerView: 2,
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
    1280: {
      slidesPerView: 4,
    }
  }
})

const structureSlider = new Swiper('#structureSlider', {
  slidesPerView: 'auto',
  spaceBetween: 40,
  pagination: {
    el: '.pagination',
    ...defaultPaginationSettings
  },
  navigation: {
    nextEl: '.pagination__button--next',
    prevEl: '.pagination__button--prev'
  }
})

const exampleSliderContainers = [...document.querySelectorAll('.examples-slideshow')]
exampleSliderContainers.forEach(slider => {
  const swiper = slider.querySelector('.examples-swiper');
  const paginationEl = slider.querySelector('.pagination')
  const nextEl = slider.querySelector('.pagination__button--next');
  const prevEl = slider.querySelector('.pagination__button--prev');

  new Swiper(swiper, {
    loop: true,
    pagination: {
      el: paginationEl,
      ...defaultPaginationSettings
    },
    navigation: {
      nextEl,
      prevEl
    }
  })
})
